import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import { LinkIcon, MailIcon, OrganizationIcon } from '../../../../../../../assets';
import { ShareStep } from '../../ShareDialog';
import { Container, OptionContainer, OptionText } from './ShareOptions.styles';

interface ShareOptionProps {
  icon: JSX.Element;
  text: string;
  onClick?: (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const ShareOption = ({ icon, text, onClick }: ShareOptionProps) => {
  return (
    <OptionContainer onClick={onClick}>
      {icon}
      <OptionText>{text}</OptionText>
    </OptionContainer>
  );
};

interface ShareOptionsProps {
  listingId: string;
  setStep: (step: ShareStep) => void;
}

const ShareOptions = ({ listingId, setStep }: ShareOptionsProps) => {
  const { t } = useTranslation();

  const handleCopyLink = (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    ev.stopPropagation();
    const environmentURL = process.env.REACT_APP_URL;
    const listingURL = `${environmentURL}/app/listings/${listingId}`;
    void navigator.clipboard.writeText(listingURL);
    toast.success(t('vdp.shareModal.copyLinkSuccess'));
  };

  return (
    <Container>
      <ShareOption
        icon={<OrganizationIcon />}
        text={t('vdp.shareModal.organization')}
        onClick={() => setStep(ShareStep.SHARE_WITH_ORG_STEP_1)}
      />
      <ShareOption
        icon={<MailIcon />}
        text={t('vdp.shareModal.email')}
        onClick={() => setStep(ShareStep.SHARE_WITH_EMAIL)}
      />
      <ShareOption icon={<LinkIcon />} text={t('vdp.shareModal.copyLink')} onClick={handleCopyLink} />
    </Container>
  );
};

export default ShareOptions;
